import ValidateUserAndPresentLogon from "features/Header/PuzzelTelephone/components/ValidateUserAndPresentLogon";
import { UserValidationProvider } from "features/Header/PuzzelTelephone/provider/contexts/UserValidationContext";
import { ReactElement, ReactNode } from "react";

type Props = {
  children: ReactNode;
};

// PuzzelAuthenticationProvider lives higher up (Header.tsx) since AdminLinks needs it too.
export const PuzzelProvider = ({ children }: Props): ReactElement | null => (
  <UserValidationProvider>
    <ValidateUserAndPresentLogon>{children}</ValidateUserAndPresentLogon>
  </UserValidationProvider>
);
